import { createContext, useContext, useState, useEffect, useCallback } from "react";
import fr from "./fr.json";
import en from "./en.json";

const translations = { fr, en };
const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("bizou_lang");
    if (saved && translations[saved]) return saved;
    const browserLang = navigator.language?.slice(0, 2);
    return translations[browserLang] ? browserLang : "fr";
  });

  useEffect(() => {
    localStorage.setItem("bizou_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key, params) => {
    const keys = key.split(".");
    let val = translations[lang];
    for (const k of keys) {
      val = val?.[k];
      if (val === undefined) {
        let fallback = translations.fr;
        for (const fk of keys) fallback = fallback?.[fk];
        val = fallback || key;
        break;
      }
    }
    if (params && typeof val === "string") {
      Object.entries(params).forEach(([k, v]) => {
        val = val.replace(new RegExp(`\\{${k}\\}`, "g"), v);
      });
    }
    return val;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  return useContext(LanguageContext);
}
